export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ05.028d2c24.mp3";